import { parseBioSegments, REDACTED_PLACEHOLDER } from '@pigeons/shared-search-utility/freelancer';
import { useAuth } from '../../context/auth';

interface ProfileBioTextProps {
  bio: string | null | undefined;
  profileId: string;
  className?: string;
  skipRedaction?: boolean;
}

const ProfileBioText = ({
  bio,
  profileId,
  className,
  skipRedaction = false,
}: ProfileBioTextProps) => {
  const { user } = useAuth();

  if (!bio) {
    return null;
  }

  const shouldRedact = !skipRedaction && user?.id !== profileId;

  if (!shouldRedact) {
    return <span className={className}>{bio}</span>;
  }

  const segments = parseBioSegments(bio);

  return (
    <span className={className}>
      {segments.map((segment, index) =>
        segment.kind === 'redacted' ? (
          <span key={index} className="text-gray-400">
            {REDACTED_PLACEHOLDER}
          </span>
        ) : (
          <span key={index}>{segment.value}</span>
        )
      )}
    </span>
  );
};

export default ProfileBioText;
